// The Esc key of the shared bulk bar (`BulkSelectionBar`): clears the selection it shows. Screens that
// already own Esc for their list (grid, board, inbox, workflows) turn this off with `escapeClears={false}`.
import { defineCommand, defineScope } from '@dataroom/interaction';
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';

export type BulkSelectionContext = { clear: () => void };

export const bulkSelectionScope = defineScope<BulkSelectionContext>({
  id: 'bulk.selection',
  kind: 'list',
  title: () => t('interaction.scope.bulk'),
});

export default defineAppCommands({
  id: 'bulk.selection',
  scopes: [bulkSelectionScope],
  commands: [
    defineCommand<BulkSelectionContext>({
      id: 'bulk.clearSelection',
      scope: bulkSelectionScope,
      title: () => t('interaction.cmd.clearSelection'),
      shortcut: 'escape',
      hidden: true,
      run: (c) => c.clear(),
    }),
  ],
});
